'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSupplementalInitialMessagesFailed = exports.fetchSupplementalInitialMessagesSucceeded = exports.fetchSupplementalInitialMessagesRequested = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchSupplementalInitialMessages = fetchSupplementalInitialMessages;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _fetchSupplementalInitialMessages = require('../clients/fetchSupplementalInitialMessages');

var _buildScheduledMessage = require('conversations-schema/factories/PubNubMessageFactory/buildScheduledMessage');

var _HttpStatusCodes = require('conversations-schema/constants/HttpStatusCodes');

var _MessageDescriptorSources = require('conversations-schema/constants/MessageDescriptorSources');

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _getSessionId = require('../selectors/widgetDataSelectors/getSessionId');

var _getAssignedResponderInWidget = require('../responders/selectors/getAssignedResponderInWidget');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var fetchSupplementalInitialMessagesRequested = exports.fetchSupplementalInitialMessagesRequested = (0, _reduxActions.createAction)(ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES);

var fetchSupplementalInitialMessagesSucceeded = exports.fetchSupplementalInitialMessagesSucceeded = (0, _reduxActions.createAction)(ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES_SUCCEEDED, function (supplementalInitialMessages) {
  return {
    supplementalInitialMessages: supplementalInitialMessages.map(function (messageContainer) {
      delete messageContainer.message.clientTs;
      delete messageContainer.message.timestamp;

      // Patch around invalid type returned by bots-public/v1/welcome
      messageContainer.message.metadata[_messageTypes.MESSAGE_TYPE_ID] = _messageTypes.INITIAL_MESSAGE;

      return (0, _immutable.Map)({
        message: (0, _buildScheduledMessage.buildScheduledMessage)(_extends({}, messageContainer.message, {
          descriptor: { source: _MessageDescriptorSources.SUPPLEMENTAL_INITIAL_MESSAGE }
        })),
        continueAfterMs: messageContainer.continueAfterMs
      });
    })
  };
});

var fetchSupplementalInitialMessagesFailed = exports.fetchSupplementalInitialMessagesFailed = (0, _reduxActions.createAction)(ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES_FAILED, function (error) {
  return { error: error };
});

function fetchSupplementalInitialMessages() {
  return function (dispatch, getState) {
    var responder = (0, _getAssignedResponderInWidget.getAssignedResponderInWidget)(getState());
    var botId = (0, _responderGetters.getUserId)(responder);
    var sessionId = (0, _getSessionId.getSessionId)(getState());

    dispatch(fetchSupplementalInitialMessagesRequested());
    (0, _fetchSupplementalInitialMessages.fetchSupplementalInitialMessages)({ botId: botId, sessionId: sessionId }).then(function (response) {
      var messages = response.status === _HttpStatusCodes.NO_CONTENT ? [] : response.data;
      dispatch(fetchSupplementalInitialMessagesSucceeded(messages));
    }, function (error) {
      dispatch(fetchSupplementalInitialMessagesFailed(error));
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/SupplementalInitialMessagesActions.js
// module id = 437
// module chunks = 2 3